export enum DiscoverTypeRoute {
  Movies = 'movies',
  Tv = 'tv',
}

export enum DiscoverTypeLabel {
  Movies = 'Movies',
  Tv = 'TV',
}

export enum ScreenFormatType {
  Episode = 'EPISODE',
  Movie = 'MOVIE',
  Season = 'SEASON',
  Tv = 'TV',
}

export enum SectionType {
  Episode = 'EPISODE',
  Movie = 'MOVIE',
  Person = 'PERSON',
  Season = 'SEASON',
  Tv = 'TV',
}

export enum SectionTypeRoute {
  Episode = 'episode',
  Movie = 'movie',
  Person = 'person',
  Season = 'season',
  Tv = 'tv',
}
